<template>
    <div>
        <template v-if="purchase.actions.customer.supplementary_agreement === 'create'">
            <b-dropdown text="Заключить дополнительное соглашение" variant="custom-green" v-if="!createSupplementaryAgreement">
                <b-dropdown-item class="fs-14" v-for="type in $globalDictionaries.fl44SupplementaryAgreementTypes" :key="type.id" @click="createClicked(type.id)">{{ type.title }}</b-dropdown-item>
            </b-dropdown>
            <component :is="createComponent" v-else @cancel="createSupplementaryAgreement = false" :purchase="purchase" @done="onSend" />
        </template>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Fl44UnknownVolumeCreateSupplementaryAgreement from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-create-supplementary-agreement.vue';
import Fl44UnknownVolumeCreateSupplementaryAgreementTermination from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-create-supplementary-agreement-termination.vue';

export default {
    name: 'private-fl44-unknown-volume-send-supplementary-agreement-customer-block',
    components: { Fl44UnknownVolumeCreateSupplementaryAgreement },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            createSupplementaryAgreement: false,
            form: {
                attachment: null
            },
            formDisagreement: {
                contract: null,
                disagreement: null
            },
            isDataSending: false,
            type: 'regular'
        };
    },
    validations() {
        return {
            form: {
                attachment: {
                    required
                }
            },
            formDisagreement: {
                contract: {
                    required
                },
                disagreement: {
                    required
                }
            }
        };
    },
    methods: {
        createClicked(typeId) {
            this.type = typeId;
            this.createSupplementaryAgreement = true;
        },
        onSend() {
            this.createSupplementaryAgreement = false;
            this.$emit('refresh', null);
        }
    },
    computed: {
        createComponent() {
            switch (this.type) {
                case 'termination':
                    return Fl44UnknownVolumeCreateSupplementaryAgreementTermination;
                default:
                    return Fl44UnknownVolumeCreateSupplementaryAgreement;
            }
        }
    }
};
</script>
